import { FilterType, IFilterCategoryItem } from '@/models/filters.model';
import { TFunction } from 'i18next';
import { ICategory } from '@/models/categories.model';

type TCategoryOptionSource = Pick<ICategory, 'id' | 'name'> | Pick<IFilterCategoryItem, 'id' | 'name'>;

export const getVisibilityOptions = (t: TFunction) => [
  { value: true, label: t('filter_visible') },
  { value: false, label: t('filter_non_visible') },
];

export const getTypeOptions = (t: TFunction) => {
  return Object.values(FilterType).map((role) => ({
    label: t(`filters_${role}`),
    value: role,
  }));
};

export const getCategoriesOptions = (
  categories: TCategoryOptionSource[],
  selectedCategories: TCategoryOptionSource[] = [],
) => {
  const byId = new Map<string, string>();

  selectedCategories.forEach((category) => {
    if (category?.id && category?.name) {
      byId.set(category.id, category.name);
    }
  });

  categories?.forEach((category) => {
    if (category?.id && category?.name) {
      byId.set(category.id, category.name);
    }
  });

  return Array.from(byId, ([value, label]) => ({ value, label }));
};
